import { MegastarFileType } from '@/api/project';

type CompetitorVariableInput = {
    variableName: string;
    competitor?: boolean;
    isTotal?: boolean;
    fileType: MegastarFileType;
};

/**
 * Selects the competitor variables whose modeled contribution feeds the
 * "Competitor Media Effect" graph and the KPI effect card (output/effect path).
 *
 * Only output-file competitor variables are considered. When the model contains
 * one or more `isTotal` aggregate variables, the total takes precedence: the
 * per-channel competitor contributions are already subsumed by it, so summing
 * both would double-count the modeled effect. In that case only the totals are
 * returned. When no total is present, all per-channel competitor contributions
 * are returned (the original behaviour).
 */
export const getCompetitorEffectVariables = (
    dashboardVariables: CompetitorVariableInput[],
): string[] => {
    const competitorOutputVariables = dashboardVariables.filter(
        (variable) =>
            variable.competitor &&
            variable.fileType === MegastarFileType.output,
    );

    const totalCompetitorVariables = competitorOutputVariables.filter(
        (variable) => variable.isTotal,
    );

    return (
        totalCompetitorVariables.length > 0
            ? totalCompetitorVariables
            : competitorOutputVariables
    ).map((variable) => variable.variableName);
};
